import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface ImovelTipo {
  tipo: string | null;
}

/**
 * Hook para buscar os tipos de imóveis disponíveis (que têm pelo menos 1 imóvel ativo)
 */
export function useAvailablePropertyTypes(imobiliariaId?: string) {
  return useQuery({
    queryKey: ['available-property-types', imobiliariaId],
    queryFn: async () => {
      // Usa view pública do HouseBit (já filtra imóveis ativos)
      let query = supabase
        .from('imoveis_public')
        .select('tipo');

      if (imobiliariaId) {
        query = query.eq('imobiliaria_id', imobiliariaId);
      }

      const { data, error } = await query;

      if (error) {
        console.error('Erro ao buscar tipos disponíveis:', error);
        throw error;
      }

      // Extrair tipos únicos e não nulos
      const uniqueTypes = new Set<string>();
      (data as ImovelTipo[] | null)?.forEach(item => {
        if (item.tipo && typeof item.tipo === 'string') {
          uniqueTypes.add(item.tipo.toLowerCase());
        }
      });

      return Array.from(uniqueTypes).sort();
    },
    enabled: true,
    staleTime: 5 * 60 * 1000, // Cache por 5 minutos
  });
}
